(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["shopping-story"]) return;
  try {
    
document.querySelectorAll('.shopping-story').forEach(story=>{const buttons=story.querySelectorAll('[data-story-filter]');const cards=story.querySelectorAll('[data-story-group]');const status=story.querySelector('[data-story-count]');buttons.forEach(button=>button.addEventListener('click',()=>{let shown=0;cards.forEach(card=>{card.hidden=button.dataset.storyFilter!=='all'&&card.dataset.storyGroup!==button.dataset.storyFilter;if(!card.hidden)shown++});buttons.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));status.textContent=shown+' products';}));});

  } catch(e) { console.error(e); }
})();
})();
